export const YEAR = 'ano'
export const MONTH = 'mês'
